const objectToSelect = object => Object.keys(object)
  .map(e => ({ code: e, name: object[e] }))

export default {
  menuOpen: state => state.menuOpen,
  platformName: state => (state.specificManager || {}).platformName,
  specificManager: state => state.specificManager,
  languages: state => objectToSelect(state.languages),
  countries: state => objectToSelect(state.countries)
}



// WEBPACK FOOTER //
// ./src/store/application/getters.js